import { defineStore } from 'pinia'
import axios from "@/axios";


export const useCountriesStore = defineStore({
    id: 'countries',
    state: () => ({
        countries: [],
        countriesOrder: [],
        cities: [],
    }),
    actions: {
        async fetchCountries() {
            const response = await axios.get('/countries')
            this.countries = response.data;
            this.countriesOrder = this.countries.data.reverse();
            
        },
        async fetchCities(id) {
            const response = await axios.get(`/store-by-country/${id}`);
            this.cities = response.data;
        },
    },

})